import { cB as o, cNotM as e, cE as r, cM as i } from "./ghl-ui.es384.js";
const n = o("divider", `
 position: relative;
 display: flex;
 width: 100%;
 box-sizing: border-box;
 font-size: 16px;
 color: var(--n-text-color);
 transition:
 color .3s var(--n-bezier),
 background-color .3s var(--n-bezier);
`, [e("vertical", `
 margin-top: 24px;
 margin-bottom: 24px;
 `, [e("no-title", `
 display: flex;
 align-items: center;
 `)]), r("title", `
 display: flex;
 align-items: center;
 margin-left: 12px;
 margin-right: 12px;
 white-space: nowrap;
 font-weight: var(--n-font-weight);
 `), i("title-position-left", [r("line", [i("left", {
  width: "28px"
})])]), i("title-position-right", [r("line", [i("right", {
  width: "28px"
})])]), i("dashed", [r("line", `
 background-color: #0000;
 height: 0px;
 width: 100%;
 border-style: dashed;
 border-width: 1px 0 0;
 `)]), i("vertical", `
 display: inline-block;
 height: 1em;
 margin: 0 8px;
 vertical-align: middle;
 width: 1px;
 `), r("line", `
 border: none;
 transition: background-color .3s var(--n-bezier), border-color .3s var(--n-bezier);
 height: 1px;
 width: 100%;
 margin: 0;
 `), e("dashed", [r("line", {
  backgroundColor: "var(--n-color)"
})]), i("dashed", [r("line", {
  borderColor: "var(--n-color)"
})]), i("vertical", {
  backgroundColor: "var(--n-color)"
})]);
export {
  n as default
};
